export default "__VITE_ASSET__Ol3CU4N___"